import React from 'react';
import { UserDashboard } from '../components';

const UserDashboardPage = () => {
  return <UserDashboard />;
};

export default UserDashboardPage;